import { render, staticRenderFns } from "./uploadGradeSuccess.vue?vue&type=template&id=0ecf20ba&scoped=true"
import script from "./uploadGradeSuccess.vue?vue&type=script&lang=js"
export * from "./uploadGradeSuccess.vue?vue&type=script&lang=js"
import style0 from "./uploadGradeSuccess.vue?vue&type=style&index=0&id=0ecf20ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf20ba",
  null
  
)

export default component.exports